import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!

  return (_openBlock(), _createBlock(_component_ontos_computed_input, {
    label: _ctx.$tt('alias-url'),
    class: _normalizeClass(["ontos-code", {'required unique': !_ctx.fixed}]),
    value: _ctx.alias,
    manual: _ctx.manual,
    "onInput:manual": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:manual', $event))),
    source: _ctx.source,
    readonly: _ctx.fixed,
    compute: _ctx.$utils.aliasSuggestion,
    computeOnInput: _ctx.$utils.incompleteAliasSuggestion,
    "error-messages": _ctx.errorMessage,
    hint: _ctx.formula ? _ctx.$tt('formula-name-hint', {name: _ctx.formula}) : '',
    "hide-details": "auto",
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event))),
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur')))
  }, null, 8, ["label", "class", "value", "manual", "source", "readonly", "compute", "computeOnInput", "error-messages", "hint"]))
}